<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table #dt [value]="reportes" [columns]="cols" dataKey="id"
                     selectionMode="multiple" [(selection)]="reportesSeleccionados"
                     [rowHover]="true" [rows]="10" [paginator]="true"
                     [scrollable]="false" [responsive]='true'
                     [filterDelay]="0" [globalFilterFields]="['nombre','tipo','clase','motor']"
                     sortMode="multiple" [multiSortMeta]="multiSortMeta"
                     [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                     styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center justify-content-start">
                            <button pButton type="button" 
                                    label="{{appConfig.ux.actions.create}}" 
                                    icon="pi pi-plus"
                                    (click)="nuevoReporte();"
                                    >
                            </button>
                            <!--[disabled]="!puedeEjecutar('crear')"-->
                            <button pButton pRipple type="button"
                                    pTooltip="Borrar seleccionados" tooltipPosition="bottom"
                                    icon="pi pi-trash" class="p-button-help ml-1"
                                    (click)="confirmarBorrarSeleccionados();" 
                                    [disabled]="!(reportesSeleccionados && reportesSeleccionados.length)">
                            </button>
                            <!--                            [disabled]="!puedeEjecutar('borrado') 
                                                                || !(reportesSeleccionados && reportesSeleccionados.length)"-->
                        </div>
                        <span class="p-input-icon-left ml-1 w-full">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."/>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 3rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </div>
                    </th>
                    <th style="width: 12rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td style="width: 3rem">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <td *ngFor="let col of columns" [hidden]="!col.visible">
                        {{rowData[col.field]}}
                    </td>
                    <td style="width: 12rem">
                        <button pButton type="button" 
                                pTooltip="{{appConfig.ux.actions.edit}}" tooltipPosition="bottom" 
                                icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                                (click)="editarReporte(rowData);"
                                >
                        </button>
                        <!--[disabled]="!puedeEjecutar('escritura')"-->
                        <button pButton type="button" 
                                pTooltip="{{appConfig.ux.actions.delete}}" tooltipPosition="bottom" 
                                icon="pi pi-trash" class="p-button-rounded p-button-text p-button-secondary"
                                (click)="confirmarBorrarReporte(rowData);"
                                >
                        </button>
                        <!--[disabled]="!puedeEjecutar('borrado')"-->
                    </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">{{appConfig.ux.emptyMsg}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="dt.reset();">
                    </button>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!-- Diálogos de creación/edición de reporte -->
<p-dialog [header]="(reporte && reporte.id) ? 'Editar Reporte' : 'Nuevo Reporte'" 
          [(visible)]="mostrarEditor && reporte" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditor=false;">
    <form #reporteEditorForm="ngForm"
          (ngSubmit)="guardarReporte();"
          [ngClass]="{'disabledForm': false}"><!--reporteEditorForm.reset();-->
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <h2 class="p-text-uppercase">{{reporte.name}}</h2>
                <h6>{{ getNombreArchivo(reporte.url) }}</h6>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Nombre</label>
                <input #nombre="ngModel" id="nombre" name="nombre" type="text" 
                       [(ngModel)]="reporte.name" 
                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                           *ngIf="reporteEditorForm.controls['nombre']
                           && !reporteEditorForm.controls['nombre'].valid 
                           && (reporteEditorForm.controls['nombre'].dirty 
                           || reporteEditorForm.controls['nombre'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="motor">Motor de ejecución</label>
                <p-dropdown id="motor" name="motor" 
                            [options]="motoresReporte" optionLabel="name" 
                            [(ngModel)]="motorReporte"
                            placeholder="Seleccione un motor de ejecución..."
                            emptyMessage="{{appConfig.ux.emptyMsg}}"
                            [showClear]="true"
                            emptyFilterMessage="{{appConfig.ux.emptyMsg}}"
                            [showTransitionOptions]="'.18s'" [hideTransitionOptions]="'.3s'"
                            required>
                </p-dropdown>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="modulo">Identificador de la Entidad<span class="required-asterisk">*</span></label>
                <button if="modulo"
                        pButton type="button" 
                        label="{{(catalogoModulosArbolSimpleNodoSeleccionado && catalogoModulosArbolSimpleNodoSeleccionado['data']) ? catalogoModulosArbolSimpleNodoSeleccionado['data']['routerLink'] : '(Seleccionar)'}}"
                        class="p-button-outlined p-button-plain p-text-left p-p-3"
                        (click)="pt.resetFilter(); cargarModulos();">
                </button>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="clase">Clase de Reporte</label>
                <p-dropdown id="clase" name="clase" 
                            [options]="clasesReporte" optionLabel="name" 
                            [(ngModel)]="claseReporte"
                            placeholder="Seleccione una clase..."
                            emptyMessage="{{appConfig.ux.emptyMsg}}"
                            [showClear]="true"
                            emptyFilterMessage="{{appConfig.ux.emptyMsg}}"
                            [showTransitionOptions]="'.18s'" [hideTransitionOptions]="'.3s'"
                            required>
                </p-dropdown>
            </div>
            <div class="p-field col-12">
                <button pButton type="button" 
                        label="{{reporte.url ? 'Reemplazar archivo' : 'Agregar archivo'}}"
                        icon="pi pi-upload" class="p-button-secondary p-p-3"
                        (click)="mostrarCargaArchivoReporte($event);"
                        [disabled]="!reporteEditorForm.valid"
                        title="{{getNombreArchivo(reporte.url)}}">
                </button>
            </div>
            <div class="p-field col-12">
                <label for="descripcion">Descripción</label>
                <textarea #descripcion="ngModel" id="descripcion" name="descripcion" type="text"
                          [(ngModel)]="reporte.description" 
                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                          [rows]="5"
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="reporteEditorForm.controls['descripcion'] 
                           && !reporteEditorForm.controls['descripcion'].valid 
                           && (reporteEditorForm.controls['descripcion'].dirty 
                           || reporteEditorForm.controls['descripcion'].touched)">
                </p-message>
            </div>
        </div>
        <p-footer>
            <div class="flex align-items-center justify-content-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditor=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!reporteEditorForm.valid
                        || !catalogoModulosArbolSimpleNodoSeleccionado || !claseReporte || !motorReporte)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!-- Diálogo de selección de modulo-->
<p-dialog header="Módulos/Submódulos" 
          [(visible)]="mostrarEditorModulo" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '55vw', '640px': '80vw'}" [style]="{width: '55vw'}"
          (onHide)="mostrarEditorModulo=false;">
    <p-messages [(value)]="msgs"></p-messages>
    <h2 class="p-text-uppercase p-m-0">{{catalogoModulosArbolSimpleNodoSeleccionado ? catalogoModulosArbolSimpleNodoSeleccionado['label'] : '(Seleccionar)'}}</h2>
    <p-tree #pt [value]="catalogoModulosArbolSimple" selectionMode="single"
            [(selection)]="catalogoModulosArbolSimpleNodoSeleccionado"
            (onNodeSelect)="asignarModulo();"
            emptyMessage="{{appConfig.ux.emptyMsg}}"
            [filter]="true" filterMode="lenient" filterBy="codigo,label"
            filterPlaceholder="Buscar..."
            scrollHeight="400px">
        <ng-template let-node  pTemplate="header">
            <div class="grid p-nogutter p-justify-end">
                <button pButton type="button" 
                        icon="pi pi-sort-down" class="p-button-rounded p-button-text"
                        (click)="ui.expandirArbol(catalogoModulosArbolSimple);">
                </button>
                <button pButton type="button" 
                        icon="pi pi-sort-up" class="p-button-rounded p-button-text p-button-secondary"
                        (click)="ui.minimizarArbol(catalogoModulosArbolSimple);">
                </button>
            </div>
        </ng-template>
        <ng-template let-node  pTemplate="default">
            <div>{{node.label}}</div>
        </ng-template>
        <ng-template pTemplate="footer">
            <div *ngIf="catalogoModulosArbolSimple && !catalogoModulosArbolSimple.length">
                <strong>Aún sin definir los módulos del Sistema.</strong>
            </div>
        </ng-template>
    </p-tree>
</p-dialog>
<!--Diálogo de carga de reporte y sus detalles desde excel -->
<p-dialog header="Cargar Reporte"
          [(visible)]="mostrarVentanaCargaArchivos && reporte" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '55vw', '640px': '80vw'}" [style]="{width: '55vw'}"
          (onHide)="mostrarVentanaCargaArchivos=false;">
    <form [formGroup]="cargarArchivosForm">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <label for="nombre">Nombre</label>
                <input #nombre="ngModel" id="nombre" name="nombre" type="text" 
                       [(ngModel)]="reporte.name" 
                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                           *ngIf="cargarArchivosForm.controls['nombre']
                           && !cargarArchivosForm.controls['nombre'].valid 
                           && (cargarArchivosForm.controls['nombre'].dirty 
                           || cargarArchivosForm.controls['nombre'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12">
                <label>Archivo de Datos de Escalafón</label>
                <p-fileUpload 
                    #fileInput name="file" 
                    accept=".prpt,.jasper" maxFileSize="10000000" 
                    [auto]="false" fileLimit="1" 
                    [chooseLabel]="'Elegir Archivo'" 
                    [uploadLabel]="'Subir'" [showUploadButton]="false"
                    [cancelLabel]="'Cancelar'" 
                    url="{{uploadServiceURL}}" 
                    [headers]="httpHeaders" 
                    (onBeforeUpload)="onBeforeUpload($event)" 
                    (onUpload)="onUpload($event)" 
                    (onSelect)="onArchivoSeleccionado($event)">
                </p-fileUpload>
                <p-message severity="error" text="El archivo es requerido" *ngIf="file_error"></p-message>
            </div>
        </div>
        <p-footer>
            <div class="flex align-items-center justify-content-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="toggleModal(false);">
                </button>
                <button pButton type="button"
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        (click)="cargarArchivos();"
                        [disabled]="(!cargarArchivosForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton type="button" 
                label="No"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton type="button" 
                label="Sí"
                icon="pi pi-check" class="p-ml-2"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>